// System sub-layout — just renders Outlet (AdminLayout already provides nav + breadcrumbs)
import { Outlet } from 'react-router-dom';
export default function SystemLayout() {
  return <Outlet />;
}
